export default "__VITE_ASSET__DlshtHbs__"